import { pageInfo, detailInfo, submitApproval, approvalRejected } from './../api';
import { getRejectReasonList, getRejectStatusList} from '../../../../api/selects'
const rejectApproval = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailInfoObj: null,
    submitApprovalObj: null,
    rejectReasonListObj: null,
    rejectStatusListObj: null,
    approvalRejectedObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data.obj || {};
    },
    SUBMIT_APPROVAL(state, data) {
      state.submitApprovalObj = data;
    },
    REJECT_REASON_LIST(state, data) {
      state.rejectReasonListObj = data;
    },
    REJECT_STATUS_LIST(state, data) {
      state.rejectStatusListObj = data;
    },
    APPROVAL_REJECTED(state, data) {
      state.approvalRejectedObj = data;
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async submitApproval({ commit }, obj) {
      let resp = await submitApproval(obj);
      commit('SUBMIT_APPROVAL', resp);
      return resp;
    },
    async approvalRejected({ commit }, obj) {
      let resp = await approvalRejected(obj);
      commit('APPROVAL_REJECTED', resp);
      return resp;
    },
    /**
     * 拒收原因下拉框
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async rejectReasonList({ commit }, obj) {
      let resp = await getRejectReasonList(obj);
      commit('REJECT_REASON_LIST', resp);
    },
    /**
     * 单据状态
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async rejectStatusList({ commit }, obj) {
      let resp = await getRejectStatusList(obj);
      commit('REJECT_STATUS_LIST', resp);
    },
  }
}
export default rejectApproval



// WEBPACK FOOTER //
// ./src/page/reject/rejectApproval/store/rejectApproval.store.js